<template>
    <div class="archive-app">
        <div class="archive-app__top-container">
            <div class="archive-app__top">
                <form
                    class="archive-app__search"
                    v-on:submit.prevent="submitForm"
                >
                    <div class="archive-app__search-input-wrapper">
                        <input placeholder="Hae" v-model="searchTerm" />
                        <button
                            type="submit"
                            class="archive-app__search-input-icon"
                            v-html="headerSearchIcon"
                        ></button>
                    </div>
                </form>
                <div class="archive-app__year">
                    <label
                        for="archive-app__change-year"
                        class="screen-reader-text"
                        >Valitse vuosi</label
                    >
                    <select
                        id="archive-app__change-year"
                        v-model="year"
                        v-on:change="changeYear"
                    >
                        <option v-bind:value="null">Valitse vuosi</option>
                        <option v-for="year in years">{{ year }}</option>
                    </select>
                    <div
                        class="archive-app__year-icon"
                        v-html="dropdownMenuIcon"
                    ></div>
                </div>
            </div>
        </div>
        <div
            class="archive-app__category-list"
            v-if="currentContentTypes.length"
        >
            <div class="archive-app__category archive-app__category--label">
                Selaa luokittain
            </div>
            <div
                class="archive-app__category"
                v-bind:class="
                    currentContentType === contentType.slug
                        ? 'archive-app__category--active'
                        : ''
                "
                v-for="contentType in currentContentTypes"
                v-on:click="setCurrentContentType(contentType.slug)"
            >
                {{ contentType.name }}&nbsp;<span
                    v-if="contentType.wwffi_count"
                >
                    ({{ contentType.wwffi_count }})</span
                >
            </div>
        </div>
        <div
            class="archive-app__category-list"
            v-if="filteredCategories.length"
        >
            <div class="archive-app__category archive-app__category--label">
                Selaa aiheittain
            </div>
            <button
                class="archive-app__category"
                v-for="category in filteredCategories"
                v-on:click="setCurrentCategory(category.slug)"
                v-bind:class="
                    currentCategory.includes(category.slug)
                        ? 'archive-app__category--active'
                        : ''
                "
            >
                #{{ category.name }}
            </button>
            <button
                class="archive-app__category archive-app__category--button"
                v-if="currentCategories.length > 10 && !showAll"
                v-on:click="showAll = true"
            >
                Näytä enemmän
            </button>
            <button
                class="archive-app__category archive-app__category--button"
                v-if="currentCategories.length > 10 && showAll"
                v-on:click="showAll = false"
            >
                Näytä vähemmän
            </button>
        </div>
        <div
            v-if="loading && results.length === 0"
            class="archive-app__loading-spinner"
        >
            <LoadingSpinner></LoadingSpinner>
        </div>
        <div class="archive-app__results">
            <div v-for="result in results">
                <div class="archive-app__result">
                    <div class="row">
                        <div class="col-lg-4 col-md-5" v-if="result.image">
                            <a
                                target="_blank"
                                v-if="result.image"
                                v-bind:href="result.url"
                                class="archive-app__result-image"
                            >
                                <ResponsiveImage v-bind:image="result.image" />
                            </a>
                        </div>
                        <div
                            v-bind:class="
                                result.image
                                    ? 'col-lg-8 col-md-7'
                                    : 'col-lg-8 offset-lg-4 col-md-7 offset-md-5'
                            "
                        >
                            <div
                                class="archive-app__result-meta"
                                v-if="result.content_type"
                            >
                                {{ result.content_type }} | {{ result.date }}
                            </div>
                            <div
                                class="archive-app__result-meta"
                                v-if="!result.content_type"
                            >
                                {{ result.date }}
                            </div>
                            <a
                                target="_blank"
                                v-bind:href="result.url"
                                class="archive-app__result-title"
                                ><h2 class="">{{ result.title }}</h2></a
                            >
                            <p
                                class="archive-app__result-description"
                                v-html="result.description"
                            ></p>

                            <div class="archive-app__result-bottom">
                                <div v-for="category in result.categories">
                                    <button
                                        v-on:click="
                                            setCurrentCategory(category.slug)
                                        "
                                        class="archive-app__result-category"
                                    >
                                        {{ category.name }}
                                    </button>
                                </div>
                                <div>
                                    <a
                                        target="_blank"
                                        v-bind:href="result.url"
                                        class="archive-app__result-button"
                                        >Lue lisää</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="results.length && (total > page * postsPerPage || loading)">
            <div class="archive-app__load-more-container">
                <button
                    class="archive-app__load-more"
                    v-on:click="loadMore"
                    v-bind:disabled="loading"
                >
                    Lataa lisää
                </button>
            </div>
        </div>
        <div v-if="error && !loading" class="archive-app__error">
            <ErrorMessage v-bind:message="errorMessage"></ErrorMessage>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
const CancelToken = axios.CancelToken;
import LoadingSpinner from '../elements/loading-spinner/LoadingSpinner.vue';
import ErrorMessage from '../elements/error-message/ErrorMessage';
import ResponsiveImage from '../elements/responsive-image/ResponsiveImage';
import headerSearchIcon from '!raw-loader!../global/assets/header-search-icon.svg';
import dropdownMenuIcon from '!raw-loader!./dropdown-menu-icon.svg';

export default {
    props: ['categories', 'years', 'api-url', 'content-types', 'error-message'],
    components: { ResponsiveImage, LoadingSpinner, ErrorMessage },
    computed: {
        filteredCategories: function () {
            return this.showAll
                ? this.currentCategories
                : this.currentCategories.slice(0, 10);
        },
    },
    data: function () {
        return {
            showAll: false,
            searchTerm: '',
            year: null,
            page: 1,
            results: [],
            total: null,
            loading: false,
            error: false,
            postsPerPage: 6,
            currentCategories: [],
            currentCategory: [],
            currentContentTypes: [],
            currentContentType: null,
            headerSearchIcon,
            dropdownMenuIcon,
        };
    },
    mounted: function () {
        if (this.$route.query.query) {
            this.searchTerm = this.$route.query.query;
        }
        if (this.$route.query.year) {
            this.year = this.$route.query.year;
        }
        if (this.$route.query.category) {
            this.currentCategory = this.$route.query.category.split(',');
        }
        if (this.$route.query['content-type']) {
            this.currentContentType = this.$route.query['content-type'];
        }
        this.cancel = null;
        this.getPosts();
    },
    methods: {
        submitForm: function (event) {
            this.updateQueryString();
            this.results = [];
            this.page = 1;
            this.setCurrentCategory(null);
            this.setCurrentContentType(null);
            this.getPosts();
            document
                .querySelector('.archive__title')
                .scrollIntoView({ behavior: 'smooth' });
        },
        setCurrentCategory: function (category) {
            if (category === null) {
                this.currentCategory = [];
            } else if (!this.currentCategory.includes(category)) {
                this.currentCategory.push(category);
            } else {
                this.currentCategory = this.currentCategory.filter(
                    (item) => item !== category
                );
            }
            this.updateQueryString();
            this.results = [];
            this.page = 1;
            this.getPosts();
            document
                .querySelector('.archive__title')
                .scrollIntoView({ behavior: 'smooth' });
        },
        setCurrentContentType: function (contentType) {
            this.currentContentType = contentType;

            this.updateQueryString();
            this.setCurrentCategory(null);
            this.results = [];
            this.page = 1;
            this.getPosts();
            document
                .querySelector('.archive__title')
                .scrollIntoView({ behavior: 'smooth' });
        },
        changeYear: function (event) {
            this.updateQueryString();
            this.page = 1;
            this.results = [];
            this.setCurrentCategory(null);
            this.setCurrentContentType(null);
            this.getPosts();
            document
                .querySelector('.archive__title')
                .scrollIntoView({ behavior: 'smooth' });
        },
        getPosts: function () {
            if (this.loading) {
                this.cancel();
            }
            this.loading = true;
            axios
                .get(this.apiUrl + 'wwffi/v1/archive', {
                    params: {
                        page: this.page,
                        query: this.searchTerm,
                        category: this.currentCategory.join(','),
                        year: this.year,
                        'content-type': this.currentContentType,
                    },
                    cancelToken: new CancelToken((c) => {
                        this.cancel = c;
                    }),
                })
                .then((data) => {
                    this.error = false;
                    this.results = this.results.concat(data.data.posts);
                    this.total = data.data.total;
                    this.loading = false;
                    this.currentCategories = _.intersectionBy(
                        data.data.categories,
                        this.categories,
                        'slug'
                    );
                    this.currentContentTypes = _.intersectionBy(
                        data.data.content_types,
                        this.contentTypes,
                        'slug'
                    );
                    this.currentContentTypes.unshift({
                        name: 'Kaikki',
                        slug: null,
                        wwffi_count: null,
                    });
                })
                .catch((error) => {
                    if (error instanceof axios.Cancel) {
                        // Cancelled, no need to handle error
                    } else {
                        console.error('Error while getting archive', error);
                        this.error = true;
                        this.loading = false;
                    }
                });
        },
        loadMore() {
            this.page = this.page + 1;
            this.getPosts();
        },
        generateSrcSet: function (input) {
            return Object.entries(input)
                .map(([key, value]) => `${value} ${key}w`)
                .join(', ');
        },
        updateQueryString: function () {
            let query = {};
            if (this.year) {
                query.year = this.year;
            }
            if (this.searchTerm) {
                query.query = this.searchTerm;
            }
            if (this.currentCategory.length) {
                query.category = this.currentCategory.join(',');
            }
            if (this.currentContentType) {
                query['content-type'] = this.currentContentType;
            }
            this.$router.push({
                query,
            });
        },
    },
};
</script>
